import $ from "jquery";
let Dispatcher;
let React;
let get_parameter_by_name;

Dispatcher = require("../legacy/dispatcher/dispatcher").default;

React = require("react");

get_parameter_by_name = require("../legacy/helpers/get_parameter_by_name")
    .default;

// new imports
import Carousel from "./nounproject-carousel";
import IconList from "./nounproject-iconlist";
import store from "../stores/reduxStore";

import { CollectionCard } from "./nounproject-collection-card";

class Collection_List extends React.Component {
    buildTitle() {
        return (
            <p>
                <a
                    href={"/search/collection/?q=" + this.state.query}
                    className="collection-show-more"
                >
                    {"View all " +
                        gettext(
                            "",
                            this.state.totalCollections + " ",
                            this.state.totalCollections
                        ) +
                        " collections"}
                </a>
            </p>
        );
    }

    componentWillMount() {
        if (this.state.collections.length === 0 && this.state.query) {
            return this.loadCollections();
        }
    }

    constructor(props) {
        super(props);

        this.displayName = "CollectionList";
        this.iconLimit = 6;
        this.theme = "dark";
        this.collectionItemWidth = 238;
        this.searchEndpoint = "/search/json/collection/";

        this.state = {
            query: get_parameter_by_name("q"),
            creator: get_parameter_by_name("creator"),
            collections: [],
            totalCollections: null,
            allCollectionsLoaded: false,
            page: 1,
            offset: 0,
            loading: false
        };
    }

    loadCollections() {
        let endpoint,
            query = "";

        if (this.state.query) {
            query = encodeURIComponent(this.state.query.trim());
        }

        if (query.length > 0 && !this.state.allCollectionsLoaded) {
            endpoint =
                this.searchEndpoint +
                "?q=" +
                this.state.query +
                "&page=" +
                this.state.page;
            if (this.state.creator) {
                endpoint = endpoint + "&creator=" + this.state.creator;
            }
            return $.get(endpoint)
                .done(
                    (_this => (data, status, xhr) => {
                        let allCollectionsLoaded;
                        let collections;
                        collections = _this.state.collections.concat(
                            data.collections
                        );
                        allCollectionsLoaded = false;
                        if (
                            data.collections.length === 0 ||
                            collections.length === data.total
                        ) {
                            allCollectionsLoaded = true;
                        }
                        _this.setState({
                            page: _this.state.page + 1,
                            collections,
                            totalCollections: data.total || 0,
                            allCollectionsLoaded,
                            maxOffset: data.total - _this.collectionLimit,
                            loading: false
                        });
                        return Dispatcher.dispatch({
                            actionType: "collectionLoadedCallback",
                            totalCollections: data.total
                        });
                    })(this)
                )
                .fail(
                    (_this => (xhr, status, err) => {
                        _this.setState({
                            ajaxFailure: true,
                            collections: _this.state.collections,
                            totalCollections: _this.state.totalCollections || 0,
                            loading: false
                        });
                        return Dispatcher.dispatch({
                            actionType: "collectionLoadedCallback",
                            totalCollections: 0
                        });
                    })(this)
                );
        }
    }

    redirectToCollection(collection, e) {
        e.preventDefault();
        return (window.location = collection.permalink);
    }

    render() {
        let collection,
            collections = this.state.collections,
            index,
            collectionCards = [],
            componentClassName = "collection-list padding-t-l padding-b-l";

        if (this.theme === "dark") {
            componentClassName += " dark";
        }

        if (collections.length === 0) {
            // If no collections, don't render anything
            return <div />;
        }

        collections.forEach(collection => {
            collectionCards.push(
                <CollectionCard collection={collection} key={collection.id} />
            );
        });

        // Pad out the collections list with dummies
        let collectionsMod = collections.length % 3,
            collectionDummies = 3 - collectionsMod;

        if (collectionDummies > 0 && collectionDummies < 3) {
            let i = 1;
            while (i <= collectionDummies) {
                collectionCards.push(
                    <div
                        className="card-item card-dummy"
                        key={"collection.dummy." + i}
                    />
                );
                i++;
            }
        }

        return (
            <section className={componentClassName}>
                <div className="container">
                    <Carousel
                        items={collectionCards}
                        itemsPerView={3}
                        type={"collections"}
                    />
                </div>
                <div className="container">{this.buildTitle()}</div>
            </section>
        );
    }
}

export default Collection_List;
